var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnockout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 121,
    viewBox: "0 0 332 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_96763)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 20.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2396_96763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 12.5H35C33.3431 12.5 32 13.8431 32 15.5C32 17.1569 33.3431 18.5 35 18.5H61C62.6569 18.5 64 17.1569 64 15.5C64 13.8431 62.6569 12.5 61 12.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 22.5H35C33.3431 22.5 32 23.8431 32 25.5C32 27.1569 33.3431 28.5 35 28.5H79C80.6569 28.5 82 27.1569 82 25.5C82 23.8431 80.6569 22.5 79 22.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 80.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 100.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2396_96763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 92.5H35C33.3431 92.5 32 93.8431 32 95.5C32 97.1569 33.3431 98.5 35 98.5H61C62.6569 98.5 64 97.1569 64 95.5C64 93.8431 62.6569 92.5 61 92.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 102.5H35C33.3431 102.5 32 103.843 32 105.5C32 107.157 33.3431 108.5 35 108.5H79C80.6569 108.5 82 107.157 82 105.5C82 103.843 80.6569 102.5 79 102.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.875 59.5L166.875 59.5C166.323 59.5 165.875 59.0523 165.875 58.5V21.5C165.875 20.9477 165.427 20.5 164.875 20.5H157.875",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.875 100.5H164.875C165.427 100.5 165.875 100.052 165.875 99.5V80.281V60.5C165.875 59.9477 166.323 59.5 166.875 59.5H173.875",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 40.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 60.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2396_96763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 52.5H209C207.343 52.5 206 53.8431 206 55.5C206 57.1569 207.343 58.5 209 58.5H235C236.657 58.5 238 57.1569 238 55.5C238 53.8431 236.657 52.5 235 52.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 62.5H209C207.343 62.5 206 63.8431 206 65.5C206 67.1569 207.343 68.5 209 68.5H253C254.657 68.5 256 67.1569 256 65.5C256 63.8431 254.657 62.5 253 62.5Z",
    fill: "#CBCDC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_96763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2396_96763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2396_96763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 92.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2396_96763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 52.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnockout);
export default __webpack_public_path__ + "static/media/knockout.7835aa60a84f307a63a5d230cfa0e16f.svg";
export { ForwardRef as ReactComponent };